import { useParams } from 'react-router-dom';

import styles from './HbsDetail.module.css';

function HbsDetail({ bulletinData }) {
	const params = useParams();

	if (!bulletinData) return <></>;

	const thisBulletinData = bulletinData[params.index];

	return (
		<>
			<button
				className={`${styles.readButton} ${styles.reversedReadButton} ${styles.nonDrag}`}
				onClick={() => {
					window.open(`https://hbs.geogo.org/reader/?${params.index}`);
				}}
			>
				학보 읽기
			</button>
			<div className={styles.page}>
				<img
					loading="lazy"
					className={`${styles.previewImg} ${styles.nonDrag}`}
					height={500}
					width={354}
					src={`https://materials.hbs.geogo.org/covers/${params.index}.webp`}
					alt={`${params.index} bulletin's cover image`}
				/>

				<div style={{ paddingLeft: 20 }} className={styles.content}>
					<div>
						<span className={styles.describe}>
							{' '}
							{`${thisBulletinData?.org ?? '학보사'}`}
						</span>
					</div>

					<div style={{ fontSize: 22, marginBottom: 20 }}>{thisBulletinData.title}</div>

					<div className={styles.wrapper}>
						<div className={styles.describe}>발행날짜</div>
						<div className={styles.info}>
							{`${thisBulletinData?.date[0] ?? 'yyyy'}. ${
								thisBulletinData?.date[1] ?? 'MM'
							}. ${thisBulletinData?.date[2] ?? 'dd'}`}
						</div>
					</div>

					{(thisBulletinData?.det ?? []).map((det) => {
						const key = Object.keys(det)[0];
						return (
							<div className={styles.wrapper} key={key}>
								<div className={styles.describe}>{key}</div>
								<div className={styles.info}>
									{`${(det[key] ?? []).map((i) => ' ' + i)}`}
								</div>
							</div>
						);
					})}

					{/* <button
					className={`${styles.readButton} ${styles.reversedReadButton} ${styles.nonDrag}`}
					onClick={() => {
						window.open(`https://hbs.geogo.org/reader/?${params.index}`);
					}}
				>
					학보 읽기
				</button> */}
				</div>
			</div>
		</>
	);
}

export default HbsDetail;
